export default "__VITE_ASSET__Dl2a8lOV__"